// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"zendesk-messenger_buttonContainer__Lf0JO","commentIcon":"zendesk-messenger_commentIcon___B3yx"};